import { render } from "./ConsultationDossier.vue?vue&type=template&id=558437d4&scoped=true"
import script from "./ConsultationDossier.vue?vue&type=script&lang=js"
export * from "./ConsultationDossier.vue?vue&type=script&lang=js"

import "./ConsultationDossier.vue?vue&type=style&index=0&id=558437d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558437d4"]])

export default __exports__